import { render, staticRenderFns } from "./mailLinkmanList.vue?vue&type=template&id=45580e2b&scoped=true&"
import script from "./mailLinkmanList.vue?vue&type=script&lang=js&"
export * from "./mailLinkmanList.vue?vue&type=script&lang=js&"
import style0 from "./mailLinkmanList.vue?vue&type=style&index=0&id=45580e2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45580e2b",
  null
  
)

export default component.exports